function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradePlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.35,
    cy: 439.91,
    rx: 159.43,
    ry: 12.46,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.91,161.59,375.6,228.07a4.62,4.62,0,0,1-7.73,1.8L356.79,218.4a4.64,4.64,0,0,0-6.44-.21l-92.53,84a4.63,4.63,0,0,1-6.07.13L193,253.47a4.63,4.63,0,0,0-6,.1L71.59,355.85l4.38-41a4.6,4.6,0,0,1,1.53-3l108.91-96.52a4.64,4.64,0,0,1,6-.09L250.92,264a4.63,4.63,0,0,0,6.07-.13l73-66.31a4.62,4.62,0,0,0,.21-6.64L319.3,179.58a4.63,4.63,0,0,1,2.28-7.73l69.88-16.18A4.62,4.62,0,0,1,396.91,161.59Z",
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.88,161.7,375.64,228a4.7,4.7,0,0,1-7.85,1.82l-11-11.34a4.71,4.71,0,0,0-6.54-.22l-92.43,83.93a4.68,4.68,0,0,1-3.35,1.22,4.61,4.61,0,0,1-2.82-1.08l-58.62-48.79a4.74,4.74,0,0,0-6.12.09L71.59,355.85l4.57-42.73,110.21-97.67a4.72,4.72,0,0,1,6.12-.09l24.91,20.73L250.87,264a4.72,4.72,0,0,0,6.16-.13L330,197.6a4.68,4.68,0,0,0,.22-6.74l-10.81-11.19a4.7,4.7,0,0,1,2.32-7.84l69.64-16.14A4.7,4.7,0,0,1,396.88,161.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 411.04,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.49,
    y: 411.04,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.36,
    y: 411.04,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.53 430.4 223.22 430.4 223.22 411.04 225.53 411.38 225.53 430.4",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.09,
    y: 411.04,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.96,
    y: 411.04,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.82,
    y: 411.04,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.69,
    y: 411.04,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191,
    y: 411.04,
    width: 85.31,
    height: 3.99,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.3,
    y: 391.67,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.79,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.66,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.53,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.39,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.26,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.12,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.99,
    y: 391.67,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.3,
    y: 391.67,
    width: 85.31,
    height: 3.99,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.44,
    y: 372.31,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.93,
    y: 372.31,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.1 391.68 212.79 391.68 212.79 372.33 215.1 372.31 215.1 391.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.66,
    y: 372.31,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.53,
    y: 372.31,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.7 391.68 248.39 391.68 248.39 372.31 250.7 372.33 250.7 391.68",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.26,
    y: 372.31,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.12,
    y: 372.31,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.44,
    y: 372.31,
    width: 85.31,
    height: 4.77,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.3,
    y: 352.96,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.79,
    y: 352.96,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.66,
    y: 352.96,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.53,
    y: 352.96,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.39,
    y: 352.96,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.26,
    y: 352.96,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.43 372.31 272.12 372.33 272.12 352.96 274.43 353.31 274.43 372.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.99,
    y: 352.96,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.3,
    y: 352.96,
    width: 85.31,
    height: 3.99,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.05,
    y: 333.6,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.54,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.4,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.27,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.14,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.87,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.73,
    y: 333.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.05,
    y: 333.6,
    width: 85.31,
    height: 3.99,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.9,
    y: 314.24,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.39,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.26,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.12,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.99,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.85,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.72,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.59,
    y: 314.24,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.9,
    y: 314.24,
    width: 85.31,
    height: 3.99,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.33,
    y: 411.33,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.82,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.69,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.56,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.42,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.29,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.15,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.02,
    y: 411.33,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.33,
    y: 411.33,
    width: 85.31,
    height: 3.99,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.36,
    y: 391.97,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.85,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.72,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.58,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.45,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.31,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.18,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.05,
    y: 391.97,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.36,
    y: 391.97,
    width: 85.31,
    height: 3.65,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.13,
    y: 372.6,
    width: 85.31,
    height: 19.36,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.62,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.49,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.35,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.22,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.09,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.95,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.82,
    y: 372.6,
    width: 2.31,
    height: 19.36,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.13,
    y: 372.6,
    width: 85.31,
    height: 3.65,
    style: {
      opacity: 0.09
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.15,
    y: 362.89,
    width: 18.69,
    height: 68.32,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "355.84 381.07 355.84 394.96 337.15 413.65 337.15 398.71 355.84 381.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.84 370.91 355.84 373.27 337.15 391.97 337.15 389.61 355.84 370.91",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 360.16,
    y: 384.9,
    width: 18.69,
    height: 46.31,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "378.85 398.55 378.85 412.3 360.16 430.98 360.16 416.2 378.85 398.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.85 392.07 378.85 394.71 360.16 413.41 360.16 410.75 378.85 392.07",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 314.13,
    y: 330.06,
    width: 18.69,
    height: 101.15,
    style: {
      fill: "#3559E0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "332.83 349.05 332.83 362.87 314.13 381.56 314.13 366.7 332.83 349.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.83 341.45 332.83 344.03 314.13 362.74 314.13 360.14 332.83 341.45",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.75,338.52a2.68,2.68,0,1,1-.85-3.69A2.69,2.69,0,0,1,325.75,338.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.76,371a2.67,2.67,0,1,1-.85-3.69A2.67,2.67,0,0,1,348.76,371Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.77,393a2.67,2.67,0,1,1-.85-3.68A2.66,2.66,0,0,1,371.77,393Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "369.51 391.56 345.79 413.65 346.49 369.58 323.48 383.81 323.48 337.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradePlanIcon);
export default __webpack_public_path__ + "static/media/upgrade_plan_icon.f9a54b69db9d9bac33eb950899fa8cdb.svg";
export { ForwardRef as ReactComponent };